import { store } from "../../../../..";
import {
    clubhouseActions,
    selectSelectedTeam,
} from "../../../../../features/clubhouse/clubhouseSlice";
import {
    globalActions,
    selectSetting,
} from "../../../../../features/global/globalSlice";
import { leagueManagementActions } from "../../../../../features/leaguemgmt/leagueManagementSlice";
import { getTeamSchedule } from "../../../../../lib/api";

export const loader = async ({ params }: any) => {
    const { teamId } = params;
    const settings = store.getState().global.settings;
    const leagues = store.getState().leaguemanagement.leagues;
    const teams = store.getState().clubhouse.teams;
    const selectedTeam = store.getState().clubhouse.selectedTeam;
    const promises = [];

    if (!selectedTeam || selectedTeam !== parseInt(teamId)) {
        store.dispatch(clubhouseActions.setSelectedTeam(parseInt(teamId, 10)));
    }

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !leagues.length &&
        promises.push(store.dispatch(leagueManagementActions.getLeagues()));
    !teams.length &&
        promises.push(
            store.dispatch(
                clubhouseActions.getTeams({
                    userId: store.getState().auth.user?.id as number,
                }),
            ),
        );

    await Promise.all([...promises]);

    const currentTeam = selectSelectedTeam(store.getState());

    const currentYear = parseInt(
        selectSetting(store.getState(), "majorybl_current_league_year")
            ?.setting,
    );

    const currentTeamsLeague = currentTeam?.leagues?.find(
        l => l.year === currentYear,
    );

    if (currentTeamsLeague?.id) {
        const league = store.getState().leaguemanagement.selectedLeague;

        if (!league) {
            store.dispatch(
                leagueManagementActions.setSelectedLeague(
                    currentTeamsLeague.id,
                ),
            );
        }
    }

    const [{ schedule }] = await Promise.all([
        getTeamSchedule(currentTeamsLeague?.id as number, teamId),
    ]);

    return {
        teamId,
        schedule,
    };
};

export default loader;
